import axios from 'axios';

const useUpdateCustomField = () => {
  const apiUrls = process.env.REACT_APP_API_URLS;
  // const apiUrl = "https://zmmbetest.etpl.cloud/"; // Default to the first URL or fallback to localhost if not available

  const updateCustomField = async (fieldId, payload) => {
    try {
      const response = await axios.put(
        `${apiUrls}/buyer_settings/custom-fields/${fieldId}/`, // Include fieldId in the URL
        payload, // Send only the field data (without the id)
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        // Assuming the response contains a message field
        return { success: true, message: response.data.message };
      } else {
        return { success: false, message: "Failed to update field. Please try again." };
      }
    } catch (error) {
      // Assuming the error response contains a message field
      const errorMessage = error.response?.data?.message || "An error occurred while updating the field.";
      return { success: false, message: errorMessage };
    }
  };

  return { updateCustomField };
};

export default useUpdateCustomField;